module.exports = __webpack_public_path__ + "img/img_kv_5_thumb.2f5466b4.jpg";